import * as _ from "lodash";
import {DisciplineService} from "./discipline.service";

class DisciplineSelectorController {

    private id: string;
    private loading: boolean;

    /* @ngInject */
    constructor(private $log: ng.ILogService,
                private disciplineService: DisciplineService) {
    }

    public $onInit() {
        this.id = "discipline-" + _.random(0, 9999);
    }

    public searchDisciplines(query) {
        return this.disciplineService.search(query);
    }

}

export const DisciplineSelectorComponent: angular.IComponentOptions = {
    bindings: {
        ngDisabled: "=",
        ngModel: "=",
        showErrors: "<"
    },
    controller: DisciplineSelectorController,
    template: require("./discipline-selector.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/assessment/discipline-selector/discipline-selector.component.ts